<template>
  <v-container>
    <v-layout row wrap>
      <v-flex>
        <div class="main-content-wrapper">
            <div class="main-content">
                <ins-loader
                    use-image="false"
                    state-title="Processing"
                    state-message="Please wait, we're processing your data."
                    state-icon="processing"
                ></ins-loader>
            </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "PurchasePolicyElantisSuccess",
  methods: {
    async createOrderPayment() {
      let params = this.$route.params;
      params['transactions_api_token'] = serviceModule.transactionsToken();
      return await this.$store
        .dispatch("fetchData", { 
            method: "post", 
            url: `/api/fdca/cfw/order/add.json`, 
            data: params
        })
        .then(({ data }) => { 
            if(data["errors"].length > 0){
              this.promptError(data["errors"])
            } else {
              this.$router.push("/purchase-policy/result")
            }
        })
        .catch(error => this.promptError(error));
    },
    promptError(error) {
      Swal.fire({
        type: 'error',
        title: 'Internal Server Error',
        text: 'Please contact administrator'
      })
    }
  },
  mounted() {
    this.createOrderPayment()
  },
};
</script>

<style lang="scss">
.main-content-wrapper {
    display: flex;
    align-items: center;
    height: 100%;

    .main-content {
        text-align: center;
        flex: 0 0 100%;
        height: min-content;
    }
}
</style>